module.exports = __webpack_public_path__ + "static/media/Layout25.f3fd2442.png";